function getBaseUrlForTag(roomTag = 'event-venue') {
  const baseUrl = App.es6.shared.fill_variables(window.__TGV_ROUTE_SEARCH, {
    roomTag,
    subdir: window.__TGV_SEARCH_FORM_DATA.subdir,
  });

  return `${baseUrl}?location_id=${window.__TGV_SEARCH_FORM_DATA.locationId}`;
}

function initMobile(container) {
  const mobileButton = document.querySelector('.js-mobile-filter-results-button');

  mobileButton.addEventListener('click', () => {
    const template = document.getElementById('filter-column-template'); // script
    const templateTemp = document.createElement('div');
    templateTemp.innerHTML = template.innerHTML;

    const modalContent = templateTemp.querySelector('.ds-modal-content');
    modalContent.innerHTML = container.cloneNode(true).innerHTML;

    document.body.appendChild(templateTemp);

    App.track.event('location_page_interaction', {
      section: 'mobile_filters_lp',
      element: 'filter_results',
      interaction: 'click',
    });

    templateTemp.querySelector('.ds-modal__close_button').addEventListener('click', () => {
      document.body.classList.remove('lp-filters-modal-open');

      App.track.event('location_page_interaction', {
        section: 'mobile_filters_lp',
        element: 'close_modal',
        interaction: 'click',
      });

      setTimeout(() => {
        document.body.removeChild(templateTemp);
      }, 500);
    });
    templateTemp.querySelector('.lp-mobile-filters-modal--clearResults').addEventListener('click', () => {
      modalContent.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((checkbox) => {
        checkbox.checked = false;
      });

      App.track.event('location_page_interaction', {
        section: 'mobile_filters_lp',
        element: 'clear_filters_button',
        interaction: 'click',
      });
    });
    templateTemp.querySelector('.lp-mobile-filters-modal--showResults').addEventListener('click', () => {
      let baseUrl = getBaseUrlForTag(window.__TGV_ROOM_TAG);
      const queryParams = [];

      modalContent.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((checkbox) => {
        if (checkbox.checked) {
          const label = checkbox.closest('label');
          const filterValue = label.dataset.filterValue;

          if (label.dataset.element === 'event_type') {
            baseUrl = getBaseUrlForTag(filterValue);
          } else {
            queryParams.push(filterValue);
          }
        }
      });

      const url = `${baseUrl}&${queryParams.join('&')}`;

      App.track.event('location_page_interaction', {
        section: 'mobile_filters_lp',
        element: 'show_results',
        interaction: 'click',
      });

      window.location.href = `${url}&trigger_section=none`; // to avoid triggering capacity section
    });

    document.querySelectorAll('.js-filters-link').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (event.target.tagName === 'INPUT') {
          return;
        }

        App.track.event('location_page_interaction', {
          section: 'mobile_filters_lp',
          element: link.dataset.element,
          element_value: link.innerText.trim(),
          interaction: 'click',
        });
      });
    });

    document.body.classList.add('lp-filters-modal-open');
  });
}

function initDesktop() {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.js-filters-link');

    if (link) {
      App.track.event('location_page_interaction', {
        section: 'filters_sidebar',
        element: link.dataset.element,
        element_value: link.innerText.trim(),
        interaction: 'click',
      });

      const moreVenuesUrl = document.querySelector('.lp-show-more-container').dataset.url;
      const filterValue = link.dataset.filterValue;
      const filterElement = link.dataset.element;
      const triggerSection = link.dataset.triggerSection;

      event.stopPropagation();
      event.preventDefault();

      if (filterElement === 'event_type') {
        window.location.href = getBaseUrlForTag(filterValue);
        return;
      }

      window.location.href = `${moreVenuesUrl}&${filterValue}&trigger_section=${triggerSection}`;
    }
  });
}

function initShowMore(isMobile) {
  document.addEventListener('click', (event) => {
    if (event.target.classList.contains('lp-show-more')) {
      event.target.closest('.lp-show-more-container').classList.toggle('lp-show-more-container--expanded');

      const isExpanded = event.target.classList.contains('lp-show-more--less');
      App.track.event('location_page_interaction', {
        section: isMobile ? 'mobile_filters_lp' : 'filters_sidebar',
        element: isExpanded ? 'show_less_button' : 'show_more_button',
        element_value: event.target.closest('.lp-show-more-container').querySelector('h3').innerText.trim(),
        interaction: 'click',
      });
    }
  });
}

export function init() {
  const container = document.querySelector('.js-filters-container');
  if (!container) {
    return;
  }

  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  if (isMobile) {
    initMobile(container);
  } else {
    initDesktop();
  }

  initShowMore(isMobile);

  // Initialize chip filters
  const chipFilters = document.querySelectorAll('.js-chip-filter');
  chipFilters.forEach(chip => {
    chip.addEventListener('click', function (event) {
      event.stopPropagation();
      event.preventDefault();

      const filterValue = this.dataset.filterValue;
      const moreVenuesUrl = document.querySelector('.lp-show-more-container').dataset.url;

      // Track analytics
      App.track.event('location_page_interaction', {
        section: 'filters_header',
        element: 'chip_filters',
        element_value: this.dataset.filterLabel,
        interaction: 'click',
      });

      window.location.href = `${moreVenuesUrl}&${filterValue}&trigger_section=chip_filters`;
    });
  });

  // Track visibility of chip filters section
  $('.lp-chip-filters-wrapper').onIntersection(() => {
    App.track.event('location_page_interaction', {
      section: 'filters_header',
      element: 'chip_filter',
      interaction: 'visible',
    });
  });

  // Initialize chip filters horizontal scroll
  const chipContainer = document.querySelector('.js-chip-filters-scroll');

  const scrollLeftButton = document.querySelector('.js-chip-filters-scroll-left');
  if (scrollLeftButton && chipContainer) {
    scrollLeftButton.addEventListener('click', () => {
      chipContainer.scrollBy({
        left: -200,
        behavior: 'smooth',
      });
    });
  }

  const scrollRightButton = document.querySelector('.js-chip-filters-scroll-right');
  if (scrollRightButton && chipContainer) {
    scrollRightButton.addEventListener('click', () => {
      chipContainer.scrollBy({
        left: 200,
        behavior: 'smooth',
      });
    });
  }

  if (chipContainer) {
    let mouseDown = false;
    let startX;
    let scrollLeft;
    let isDragging = false;
    const dragThreshold = 5;

    const startDragging = (e) => {
      mouseDown = true;
      isDragging = false;
      startX = e.pageX - chipContainer.offsetLeft;
      scrollLeft = chipContainer.scrollLeft;
    };

    const stopDragging = () => {
      mouseDown = false;
      chipContainer.classList.remove('lp-chip-filters-chips--dragging');
      // Small timeout to let click event know if we were dragging
      setTimeout(() => {
        isDragging = false;
      }, 10);
    };

    document.addEventListener('mousemove', (e) => {
      if (!mouseDown) {
        return;
      }

      const x = e.pageX - chipContainer.offsetLeft;
      const deltaX = Math.abs(x - startX);

      // only start dragging if moved more than threshold
      if (!isDragging && deltaX < dragThreshold) {
        return;
      }

      if (!isDragging) {
        isDragging = true;
        chipContainer.classList.add('lp-chip-filters-chips--dragging');
      }

      e.preventDefault();
      const scroll = x - startX;
      chipContainer.scrollLeft = scrollLeft - scroll;
    });

    chipContainer.addEventListener('mousedown', startDragging, false);
    document.addEventListener('mouseup', stopDragging, false);

    // Prevent click events on chips after dragging
    chipContainer.addEventListener('click', (e) => {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  // initialize IntersectionObserver for arrow visibility
  const firstSentinel = document.querySelector('.js-chip-filters-first-sentinel');
  const lastSentinel = document.querySelector('.js-chip-filters-last-sentinel');

  if (firstSentinel && lastSentinel && scrollLeftButton && scrollRightButton) {
    setTimeout(() => {
      const firstObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            // First chip visible - hide left arrow
            scrollLeftButton.classList.add('lp-chip-filters-arrow--hidden');
            scrollLeftButton.classList.remove('lp-chip-filters-arrow--delay');
          } else {
            // First chip not visible - show left arrow with delay
            scrollLeftButton.classList.remove('lp-chip-filters-arrow--hidden');
            scrollLeftButton.classList.add('lp-chip-filters-arrow--delay');
          }
        },
        { root: chipContainer, threshold: 0 },
      );

      const lastObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            // Last chip visible - hide right arrow
            scrollRightButton.classList.add('lp-chip-filters-arrow--hidden');
          } else {
            // Last chip not visible - show right arrow (no delay)
            scrollRightButton.classList.remove('lp-chip-filters-arrow--hidden');
          }
        },
        { root: chipContainer, threshold: 0 },
      );

      firstObserver.observe(firstSentinel);
      lastObserver.observe(lastSentinel);
    }, 100);
  }
}
